export enum BuildMode {
  KI = 'ki',
  DESCRIPTION = 'description',
  SCRATCH = 'scratch',
}

export interface JobBuilderSectionRef {
  submit: () => Promise<string>;
}

export type DescriptionButtonConfig = {
  label: string;
  disabled: boolean;
  loading?: boolean;
};
